import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { trackException } from '@fora-monorepo/webapp-analytics';

import { envConfig } from '../../config';
import { createThunkError } from '../utils';

export const getUnderMaintenance = createAsyncThunk('getUnderMaintenance', async (_, thunkAPI) => {
  if (envConfig.mockDataFrontend) {
    return true;
  }

  return axios
    .get(`${envConfig.bffBaseUri}/maintenance/isUnderMaintenance`)
    .then(res => {
      //  setUnderMaintenanceInterceptor will catch 503 and sett isUnderMaintenance
      return;
    })
    .catch(err => {
      if (err.response.status !== 503) {
        trackException(err);
      }
      return thunkAPI.rejectWithValue(createThunkError('Could not get isUnderMaintenance', err));
    });
});
